var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoiceChatFloatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81818 0.5C6.13122 0.5 6.40914 0.692801 6.50813 0.978641L10.1818 11.5864L11.6737 7.27864C11.7727 6.9928 12.0506 6.8 12.3636 6.8H15.2727C15.6744 6.8 16 7.1134 16 7.5C16 7.8866 15.6744 8.2 15.2727 8.2H12.8878L10.8718 14.0214C10.7728 14.3072 10.4949 14.5 10.1818 14.5C9.86878 14.5 9.59086 14.3072 9.49187 14.0214L5.81818 3.41359L4.32632 7.72136C4.22732 8.0072 3.9494 8.2 3.63636 8.2H0.727273C0.325611 8.2 0 7.8866 0 7.5C0 7.1134 0.325611 6.8 0.727273 6.8H3.11217L5.12823 0.978641C5.22722 0.692801 5.50514 0.5 5.81818 0.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceChatFloatIcon);
export default __webpack_public_path__ + "static/media/voice_chat_float_icon.b6d69ff0c63127ad003e8cfdbee1fb40.svg";
export { ForwardRef as ReactComponent };